import ORGANISATION_TYPES from './OrganisationTypes'

// A Member's duties: the backend's permission sets, by the names it sends and the labels shown.
export const DUTIES = [
  { id: 'Manager', label: 'Manager' },
  { id: 'StudioOperator', label: 'Studio Op' },
  { id: 'Statistician', label: 'Statistician' },
  { id: 'VideoOperator', label: 'Video Op' },
]

// Clubs have no competitions or stats, so no Statistician; the backend refuses it too.
export const dutiesForOrgType = (orgType) => {
  if (orgType === ORGANISATION_TYPES.ORG_FEDERATION) return DUTIES
  if (orgType === ORGANISATION_TYPES.ORG_CLUB) return DUTIES.filter((duty) => duty.id !== 'Statistician')
  return []
}

// The retired Stream operator is a Manager now; the backend reads it as one until its rows are rewritten.
export const normaliseDuties = (dutyIds) => [
  ...new Set((dutyIds || []).map((id) => (id === 'StreamOperator' ? 'Manager' : id))),
]

export const MANAGER = 'Manager'

// A Manager holds every duty, so the others show ticked and cannot be changed on their own.
export const holdsDuty = (dutyIds, dutyId) => {
  const held = normaliseDuties(dutyIds)
  return held.includes(dutyId) || held.includes(MANAGER)
}

export const isImpliedDuty = (dutyIds, dutyId) => dutyId !== MANAGER && normaliseDuties(dutyIds).includes(MANAGER)

// The duties to save after toggling one. Manager stands for every other duty, so it is saved alone
// (the backend does the same) and un-ticking it leaves nothing behind.
export const toggledDuties = (dutyIds, dutyId) => {
  const held = normaliseDuties(dutyIds)
  if (held.includes(dutyId)) return held.filter((id) => id !== dutyId)
  return dutyId === MANAGER ? [MANAGER] : [...held, dutyId]
}

// What the API takes for a Member's duties: org-wide grants, except a Manager limited to some
// competitions, who is one Manager grant per competition (none picked: Manager of the whole org).
export const toGrants = (dutyIds, managerCompetitionIds = []) =>
  dutyIds.flatMap((permissionSet) =>
    permissionSet === MANAGER && managerCompetitionIds.length > 0
      ? managerCompetitionIds.map((scopeId) => ({ permissionSet, scopeType: 'Competition', scopeId }))
      : [{ permissionSet }],
  )

// A Member's duties from their grants: a Manager limited to some competitions holds the duty too.
export const dutiesOfGrants = (grants) =>
  normaliseDuties(
    (grants || [])
      .filter((grant) => !grant.scopeType || grant.scopeType === 'Org' || grant.scopeType === 'Competition')
      .map((grant) => grant.permissionSet),
  )

// The competitions a Manager is limited to; empty for a Manager of the whole org.
export const managerCompetitionsOfGrants = (grants) =>
  (grants || [])
    .filter((grant) => grant.scopeType === 'Competition' && normaliseDuties([grant.permissionSet]).includes(MANAGER))
    .map((grant) => grant.scopeId)
